import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { GET_API_TOKEN, API_BASE_URL } from '../../constants/apiConstants'
import { convertUTCToLocal } from '../../helpers/Timezone'
import {
  PatientAlertsResponseType,
  TotalAlertsLast12hResponseType,
} from './types'
const baseUrl = API_BASE_URL

const baseQuery = fetchBaseQuery({
  baseUrl: `${baseUrl}/api/rpmweb`,
  prepareHeaders(headers, api) {
    let token = () => GET_API_TOKEN()
    headers.set('Authorization', `Bearer ${token()}`)
  },
})

export const PatientAlertsApi = createApi({
  reducerPath: 'patientAlertsApi',
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getPatientAlerts: builder.query<PatientAlertsResponseType, {}>({
      query: () => 'alerts',
      transformResponse: (res: PatientAlertsResponseType) => {
        const formatTzAlerts = res.alerts.map((alert) => ({
          ...alert,
          createTimestamp: convertUTCToLocal(alert.createTimestamp),
        }))
        return { ...res, alerts: formatTzAlerts }
      },
    }),
    getTotalAlertsLast12h: builder.query<TotalAlertsLast12hResponseType, {}>({
      query: () => 'alerts/12h',
    }),
  }),
})

export const { useGetPatientAlertsQuery, useGetTotalAlertsLast12hQuery } =
  PatientAlertsApi
